import { api } from "./axiosInstance";

export type BrandingResponse = {
  logo_url: string | null;
  logo_dark_url: string | null;
  logo_is_svg: boolean;
  opportunities_label: string | null;
};

export const apiGetBranding = async (): Promise<BrandingResponse> => {
  const response = await api.get("/api/v1/branding");
  return response.data;
};

export const apiUploadLogo = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  await api.post("/api/v1/branding/logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const apiUploadLogoDark = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  await api.post("/api/v1/branding/logo-dark", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const apiDeleteLogo = async (): Promise<void> => {
  await api.delete("/api/v1/branding/logo");
};

export const apiDeleteLogoDark = async (): Promise<void> => {
  await api.delete("/api/v1/branding/logo-dark");
};

export const apiUpdateOpportunitiesLabel = async (label: string | null): Promise<BrandingResponse> => {
  const response = await api.patch("/api/v1/branding/opportunities-label", { label });
  return response.data;
};
